import { validateSpanishBizumMobile } from "./bizumPhone";

/**
 * @param {{ email?: string; phone?: string; country?: string } | null | undefined} billingDetails
 * @returns {string} Locale key, or empty when Bizum can start.
 */
export function getBizumCheckoutErrorKey(billingDetails) {
  const source = billingDetails && typeof billingDetails === "object" ? billingDetails : {};
  const email = String(source.email || "").trim();
  if (!email) {
    return "checkout.bizumEmailRequired";
  }

  const phoneCheck = validateSpanishBizumMobile(source.phone);
  if (!phoneCheck.valid) {
    return phoneCheck.errorKey;
  }

  return "";
}
